import React from 'react'
import { useAllFilterBaseContext } from '../../../../../Context/AllFilterBaseContext';

export default function ExpertTypeCheckbox({ expertTypeChange, filter, locationType }) {
      const {
        state,
      } = useAllFilterBaseContext();

    const {
        // locationType,
        expertType,
      } = state;
    const isSelected2 = (id) => {
        return expertType?.some((post) => post.id == id);
    };
    
    return (
        <div>
            <>
                <h6>{filter?.title}</h6>
                {filter.values.map((value) => (
                    <div className="input-check" key={value.id}>
                        <input
                            type="checkbox"
                            className="form-control"
                            checked={isSelected2(value.id)}
                            onChange={() => expertTypeChange(value)}
                        />
                        <span>{value.title}</span>
                    </div>
                ))}
            </>
        </div>
    )
}
